import { memo } from "react";
import { StyleSheet } from "react-native-unistyles";
import { View, Button, Banner } from "@src/components";

interface RemoveAccessContentProps {
  message: string;
  onConfirm: () => void;
}

export const RemoveAccessContent = memo(({ message, onConfirm }: RemoveAccessContentProps) => {
  return (
    <View>
      <Banner variant="info" message={message} containerStyle={styles.bannerContainer} />
      <Button variant="primary" label="Confirm" size="md" onPress={onConfirm} />
    </View>
  );
});

const styles = StyleSheet.create((theme) => ({
  bannerContainer: {
    marginBottom: theme.spacing.xl,
  },
}));
